import {AnyAction} from 'redux';

import {mergeResponse, QueryState} from './Response';

import Types from '../../actions/Types';

import Actor from '../../../domain/entities/Actor';
import PaginatedResult from '../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.ResetWriterCurrentUser:
      return {};
    case Types.IndexActorsSuccess: {
      const result = action.payload as PaginatedResult<Actor>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
